import * as React from "react";

interface INavItemProps {
    cssClass: string,
}

export class NavItem extends React.Component<INavItemProps, {}> {
    constructor(props: INavItemProps) {
        super(props);
    }

    render() {
        return <li className={this.props.cssClass}
                   data-ktmenu-submenu-toggle="click" aria-haspopup="true">
            {this.props.children}
        </li>;
    }
}



// WEBPACK FOOTER //
// ./src/layout/NavItem.tsx